<template>
  <div class="quantity">
    <CustomTitle :title="sumtitle" class="title" />
    <div class="chart">
      <Echart id="quantity" :options="options" height="100%" width="100%" />
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'
import * as echarts from 'echarts'
import CustomTitle from '@/components/CustomTitle'
import config from '@/js/config'
import { months } from 'moment'

export default {
  name: 'Quantity',
  data () {
    return {
      xData: [], // 横坐标
      yData: ['一月','二月',,'三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'], // 人数数据
      taskDate: [],
      shiprate: [],
      myChartStyle: { float: 'left', width: '98%', height: '350px' }, // 图表样式
      salessum: [],
      pursum: [],
      charname: ['接单数量', '出货数量', '出货准时率'],
      sumtitle: '',
      runpcs: 0,
      allrun: 0,
      timer: '',
      xname: '件',
      compid: -1,
      dept: '',
      options: {},
      requestTimer: null,
      retryTimer: null, // 重试延时器
      mounth:0,
      years:0,
      pcssumtitle:'',
      pgsumtitle:'',
      moneysumtitle:'',
      purpcssumtitle:'',
      purpgsumtitle:'',
      purmoneysumtitle:'',
      requestUrl:'',
    }
  },
  components: {
    CustomTitle,
    Echart
  },
  watch: {},
  created () {

    this.requestUrl=window.localStorage.getItem('requestUrl')
   
    this.getsum()
    this.starttime()
  },
  mounted () {
    this.requestTimer = setInterval(() => {
      this.getsum()
    }, config.refreshTime.quantity)
  },
  methods: {
    getsum () {
      clearTimeout(this.retryTimer)
      this.compid = window.localStorage.getItem('bsmcompid')
      this.dept = window.localStorage.getItem('bsmdept')
      var paa = { compid: this.compid }
      var timeDate = new Date()
      var mounth = timeDate.getMonth() + 1
      // console.log('Salessum=' + this.dept)
      this.axios({
        method: 'post',
        //params: paa,
        //url: 'http://47.107.138.238/bsmtp/public/admin.php/Bigsreen/salessum'
        url: this.requestUrl+ '/admin.php/Bigsreen/salessum?compid='+this.compid
      })
        .then((Response) => {
          var clio = JSON.parse(Response.data)
          // console.log(this.requestUrl+ '/admin.php/Bigsreen/salessum?compid='+this.compid
          // console.log(clio)
          this.salessum = clio
          this.xData = clio['月份'] // 横坐标
          this.yData = clio['接单数量'] // 人数数据
          this.taskDate = clio['出货数量']
          this.shiprate = clio['按时交货率数量别']
          if (this.dept != 'Sales')
          {
            this.taskDate = null;
            this.shiprate = null;
            this.charname=['接单数量']
          }
          if (this.dept === 'Sales')
          {
            var sumtitle="(合计:接单"+this.sum(clio['接单数量'])+"件;出货" +this.sum(clio['出货数量'])+"件)"
            this.pcssumtitle=sumtitle;
            this.moneysumtitle="(合计:接单"+this.sum(clio['接单金额万元']).toFixed(0)+"万元;出货" +this.sum(clio['出货金额万元']).toFixed(0)+"万元)";
            this.pgsumtitle="(合计:接单"+this.sum(clio['接单款数'])+"款;出货" +this.sum(clio['出货款数'])+"款)";
          }
          else
          {
            var sumtitle="(合计:接单"+this.sum(clio['接单数量'])+"件)"
            this.pcssumtitle=sumtitle;
            this.moneysumtitle="(合计:接单"+this.sum(clio['接单金额万元']).toFixed(0)+"万元;出货" +this.sum(clio['出货金额万元']).toFixed(0)+"万元)";
            this.pgsumtitle="(合计:接单"+this.sum(clio['接单款数'])+"款)";
          }

          const today = new Date();
          const month = today.getMonth() + 1;
          const day = today.getDate();
          let yr=today.getFullYear();;
          if (month === 1 && day <= 6)
              yr=yr-1;
           

          var yy=yr+"年";

          this.years=yy;
          if( mounth>1)
            this.sumtitle =yy+'业务数量统计'+sumtitle
          else
            this.sumtitle =yy+ '业务数量统计'+sumtitle

          // console.log(this.shiprate)
          this.xname = '件'


          var scc=mounth-1;

          // var scc = clio['月份'] && clio['月份'].length ? clio['月份'].length - 1 : -1

          // console.log("scc >= 0 && mounth>1"+scc+"=="+mounth )
          if (scc >= 0 && mounth>=1) {
            // 向统计传递消息
            // pcs 上方的val
            // pcsunite 上方的label
            // sumpri 下方的val
            // priunite 下方的label
            // console.log("this is run"+clio)

            const obj = {
              two: {
                pcs: clio['接单数量'][scc],
                priunite: this.dept === 'Sales' ? '万元' : '款数',
                sumpri: this.dept === 'Sales' ? clio['接单金额万元'][scc] : clio['接单款数'][scc]
              },
              four: {
                pcs: clio['出货数量'][scc],
                priunite: this.dept === 'Sales' ? '万元' : '款数',
                sumpri: this.dept === 'Sales' ? clio['出货金额万元'][scc] : clio['出货款数'][scc]
              },
              five: {
                pcs: clio['按时交货率数量别'][scc],
                pripretxt: this.dept === 'Sales' ? '金额别' : '款数别',
                sumpri: this.dept === 'Sales' ? clio['按时交货率金额别'][scc] : clio['按时交货率款数别'][scc]
              }
            }
            this.$eventBus.$emit('SalesumOderShip', obj)
            // console.log('SalesumOderShip')
            // console.log(obj)
          }

          this.initEcharts()
        })
        .catch((error) => {
          console.log(error)
          this.retryTimer = setTimeout(() => {
            this.getsum()
          }, config.retryTime)
        })
      // 读取采购信息
      this.axios({
        method: 'post',
        //params: paa,
        url: this.requestUrl+'/admin.php/Bigsreen/puryearsumfun?compid='+this.compid
      })
        .then((Response) => {
          var clio = JSON.parse(Response.data)
          // console.log(clio)
          this.pursum = clio

          this.purpcssumtitle="(合计:采购"+this.sum(clio['采购数量'])+"件;收货" +this.sum(clio['收货数量'])+"件)";
        this.purpgsumtitle="(合计:采购"+this.sum(clio['采购款数'])+"款;收货" +this.sum(clio['收货款数'])+"款)";
        this.purmoneysumtitle="(合计:采购"+this.sum(clio['采购金额']).toFixed(0)+"万元;收货" +this.sum(clio['收货金额']).toFixed(0)+"万元)";
         console.log(this.purpcssumtitle);
         console.log(this.purpgsumtitle);
         console.log(this.purmoneysumtitle);
          // var scc = clio['年份'].length - 1
          var timeDate = new Date()
          var mounth = timeDate.getMonth() + 1
          var scc=mounth-1;
          // console.log(scc)
          if (scc >= 0 && mounth>1) {
            var ss = [
              {
                name: 'pur',
                pg: clio['采购款数'][scc],
                pcs: clio['采购数量'][scc],
                price: clio['采购金额'][scc],
                rate: clio['交货金额达成率'][scc],
                g: clio['交货款数达成率'][scc],
                MM: clio['年份'][12]
              },
              {
                name: 'back',
                g: clio['收货款数'][scc],
                pcs: clio['收货数量'][scc],
                price: clio['收货金额'][scc],
                rate: clio['交货数量达成率'][scc]
              }
            ]
            this.$eventBus.$emit('Salesumpurinfo', ss)
          }



        })
        .catch(function (error) {
          console.log(error)
        })
    },
    sum(arr) {
       return eval(arr.join("+"));
     },
    starttime () {
      this.timer = setInterval(() => {
        if (this.allrun > 1440) {
          this.getsum()
          this.allrun = 0
        }
        let timeDate = new Date()
        let mounth = timeDate.getMonth() + 1

        var mm="今年";
        if( mounth<2)
           mm=""+(timeDate.getFullYear()-1)+"年";

         if (this.runpcs === 0) {
          this.yData = this.salessum['接单数量'] // 人数数据
          this.taskDate = this.salessum['出货数量']
          if (this.dept === 'Sales')
          {
            this.shiprate = this.salessum['按时交货率数量别']
            this.charname = ['接单数量', '出货数量', '出货准时率']
          }
          else
          {
            //this.shiprate = this.salessum['按时交货率数量别']
            this.taskDate=null;
            this.shiprate =null;
            this.charname = ['接单数量']
          }
          this.xname = '件'
          this.initEcharts()
          this.runpcs = 1
          this.sumtitle = this.years+'业务数量统计'+this.pcssumtitle
        } else if (this.runpcs === 2) {
          if (this.dept === 'Sales' || this.dept === 'PUR')
          {
            this.xData = this.pursum['年份']
            this.yData = this.pursum['采购款数'] // 人数数据
            this.taskDate = this.pursum['收货款数']
            if (this.dept === 'Sales')
            {
              this.shiprate = this.pursum['交货达成率']
              this.charname = ['采购款数', '收货款数', '交货达成率']
            }
            else
            {
              this.shiprate =null// this.pursum['交货达成率']
              this.charname = ['采购款数', '收货款数']
            }
            this.xname = '款'
            this.initEcharts()
            this.sumtitle = this.years+'采购款量统计'+this.purpgsumtitle
            this.runpcs = 3
         }

        } else if (this.runpcs === 3) {
          // console.log("Salessum=dept="+this.dept);
          if (this.dept === 'Sales') {
            this.xData = this.pursum['年份']
            this.yData = this.pursum['采购金额'] // 人数数据
            this.taskDate = this.pursum['收货金额']
            this.shiprate = this.pursum['交货金额达成率']
            this.charname = ['采购金额', '收货金额', '交货达成率']
            this.xname = '万元'
            this.initEcharts()
            this.sumtitle = this.years+'采购金额统计'+this.purmoneysumtitle
          }
          this.runpcs = 0
        } else {
          if (this.dept === 'Sales') {
            this.yData = this.salessum['接单金额万元'] // 人数数据
            this.taskDate = this.salessum['出货金额万元']
            this.shiprate = this.salessum['按时交货率金额别']
            this.charname = ['接单金额万元', '出货金额万元', '出货准时率']
            this.xname = '万元'
            this.initEcharts()
            this.sumtitle = this.years+'业务金额统计'+this.moneysumtitle
          } else {
            this.yData = this.salessum['接单款数'] // 人数数据
            //this.taskDate = this.salessum['出货款数']
            this.taskDate=null;

            this.shiprate = null// this.salessum['按时交货率款数别']
            this.charname = ['接单款数']
            this.xname = '款'
            this.initEcharts()

            this.sumtitle = this.years+'业务款数统计'+this.pgsumtitle
          }
          this.runpcs = 2
        }

        this.allrun = this.allrun + 1
      }, 10 * 1000)
    },
    initEcharts () {
      // const colors = ['#5470C6', '#91CC75', '#EE6666']
      this.options = {
        // color: colors,
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        grid: {
          top: '20%',
          right: '50',
          bottom: '20',
          left: '60'
        },
        xAxis: {
          // type: "category",
          name:'月份',
          data: this.xData,
          axisLine: { lineStyle: { color: 'rgba(230, 247, 255, 0.2)' } },
          splitLine: {
            lineStyle: {
              color: 'rgba(230, 247, 255, 0.2)',
              type: 'dashed'
            }
          },
          axisLabel: {
            textStyle: { color: '#68AECE', fontSize: '12' }
          }
          // text:'月份'
        },
        // 图例
        legend: {
          data: this.charname, // ["人数", "任务数"],
          top: '0%',
          itemHeight: 12, // 图例icon高度
          itemWidth: 12, // 图例icon宽度
          right: 0,
          width: '100%',
          textStyle: {
            color: '#FFFFFF'
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '单位:' + this.xname,
            nameTextStyle: {
              color: 'rgba(230, 247, 255, 0.7)'
            },
            axisTick: { show: false },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              fontSize: 12,
              color: '#68AECE' // "rgba(255,255,255,.6)",
            },
            axisLine: {
              show: false
            }
          },
          {
            type: 'value',
            name: this.charname[3], // '按时率',
            show: true,
            axisLabel: {
              show: true,
              fontSize: 12,
              formatter: '{value} %',
              color: '#68AECE'
            },
            axisTick: { show: false },
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(230, 247, 255, 0.2)',
                type: 'dashed'
              }
            }
          }
        ],
        series: [
          {
            type: 'bar', // 形状为柱状图
            data: this.yData,
            name: this.charname[0], // "人数", // legend属性
            label: {
              // 柱状图上方文本标签，默认展示数值信息
              show: true,
              position: 'inside', // "top",
              rotate: 90,
              offset: [0, -22],
              color: '#BAE3E5',
              fontSize: 12,
              formatter: function (p) {
                let value = ''
                if (p.value > 0) {
                  value = p.value
                  if (value > 999) {
                    // 数值加千分号
                    let parts = value.toString().split('.')
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    value = parts.join('.')
                  }
                }
                return value
              }
            },
            barWidth: 17,
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#16853B'
                  },
                  {
                    offset: 1,
                    color: '#1DFA82'
                  }
                ])
              }
            }
          },
          {
            type: 'bar', // 形状为柱状图
            data: this.taskDate,
            name: this.charname[1], // legend属性
            label: {
              // 柱状图上方文本标签，默认展示数值信息
              show: true,
              position: 'inside', // "top",
              rotate: 90,
              offset: [0, -22],
              color: '#BAE3E5',
              fontSize: 12,
              formatter: function (p) {
                let value = ''
                if (p.value > 0) {
                  value = p.value
                  if (value > 999) {
                    // 数值加千分号
                    let parts = value.toString().split('.')
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    value = parts.join('.')
                  }
                }
                return value
              }
            },
            barWidth: 17,
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#0C2B5C'
                  },
                  {
                    offset: 1,
                    color: '#077AEE'
                  }
                ])
              }
            }
          },
          {
            type: 'line', // 形状为柱状图
            data: this.shiprate,
            name: this.charname[2], // legend属性
            yAxisIndex: 1,
            label: {
              // 柱状图上方文本标签，默认展示数值信息
              show: false,
              position: 'top',
              align: 'center',
              color: 'wihte',
              // rotate: 90,
              barGap: 0.2,
              // value:{value}+'%'
              formatter: function (p) {
                let value = p.value + '%'
                return value
              }
            },
            lineStyle: {
              normal: {
                width: 1
              }
            },
            itemStyle: {
              normal: {
                color: '#FFB700'
              }
            },
            smooth: false
          }
        ]
      }
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    clearInterval(this.requestTimer)
    clearTimeout(this.retryTimer)
  }
}
</script>

<style scoped lang="less">
.quantity {
  display: flex;
  flex-direction: column;
  .chart {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreenSales/components/Quantity.vue